module.exports = __webpack_public_path__ + "assets/img/money.c186c9b3.svg";